<template>
  <div class="div-table">
    <div class="columns is-gapless">
      <div class="column is-12 card-header has-text-centered">
        <strong class="is-size-7-touch">Quick Stats</strong>
      </div>
    </div>
    <div
      v-if="player.rankings.length > 0"
      :options="{ useUrlFragment: false }"
    >
      <div
        v-for="(rank, index) in player.rankings"
        :id="rank.code"
        :key="rank.code"
      >
        <div
          v-if="rank.rankings.length == 0"
          class="columns"
        >
          <div
            class="column is-12 is-flex justify-content-center align-center"
            style="padding-top:0"
          >
            No rankings found
          </div>
        </div>
        <div
          v-for="ranking in rank.rankings"
          class="columns"
        >
          <div class="column is-12">
            <strong class="is-size-7">{{ ranking.label }}:</strong>
            <div class="is-pulled-right has-text-right">
              <p>{{ ranking.points }}</p>
              <router-link :to="`/standing/${ranking.tabName}/${rank.code}`">
                Rank: #{{ ranking.rank }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Tabs, Tab} from 'vue-tabs-component'

  export default {
    components: {
      Tabs,
      Tab
    },
    props: ['player', 'tournamentType'],
    data () {
      return {
        activeTab: ''
      }
    },
    watch: {
      tournamentType: function(newType, oldType) {
        this.$refs.tabs.selectTab('#' + newType)
      }
    },
    methods: {
      tabChanged(selectedTab) {
        this.$emit('tourntypechanged', selectedTab.tab.id)
      },
      switchActiveTab (tabTitle) {
        this.switchTab()
      },
      switchTab () {
        this.activeTab = this.tabs[0]
        this.mobileTabs = !this.mobileTabs
      }
    }
  }
</script>
